/* ED 2026-10-23: one source of truth for freight messaging = the cart subtotal as rendered after BSS B2B pricing
   ([bss-b2b-cart-total-price]; cart page first, else cart drawer). Keeps in step:
   - "Fragt" / "Total inkl. fragt" lines (snippets/ed-cart-shipping-estimate.liquid)
   - free-freight text in drawer/cart page (snippets/ed-free-freight-text.liquid) + progress bars
   - header cart text (snippets/ed-header-cart-inner.liquid)
   Rule: 487 kr up to and including 3.000 kr, free from 3.000,01 kr. cart-drawer.js / cart.js re-render
   the markup on every change and BSS may rewrite the total afterwards, so we observe and re-sync. */
(function (root) {
  function parseDkk(text) {
    if (!text) return NaN;
    var m = String(text).replace(/\s|\u00a0/g, '').match(/-?[\d.]+(,\d+)?/);
    if (!m) return NaN;
    var n = parseFloat(m[0].replace(/\./g, '').replace(',', '.'));
    return isNaN(n) ? NaN : Math.round(n * 100);
  }
  function formatNum(cents) {
    var neg = cents < 0; cents = Math.abs(Math.round(cents));
    var kr = Math.floor(cents / 100), ore = cents % 100;
    return (neg ? '-' : '') + String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (ore < 10 ? '0' : '') + ore;
  }
  function currencyLabel(subtotalText) { return /DKK/.test(subtotalText || '') ? 'DKK' : 'kr'; }
  function formatDkk(cents, label) { return formatNum(cents) + ' ' + (label || 'kr'); }
  function isFree(subtotal, threshold) { return subtotal > threshold; }
  function compute(subtotal, threshold, fee) {
    var f = isFree(subtotal, threshold) ? 0 : fee;
    return { fee: f, total: subtotal + f };
  }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function setHidden(el, h) { if (el && el.hidden !== h) el.hidden = h; }
  function readSubtotal() {
    var els = document.querySelectorAll('.js-contents [bss-b2b-cart-total-price], .cart-drawer__footer [bss-b2b-cart-total-price], [bss-b2b-cart-total-price]');
    for (var i = 0; i < els.length; i++) {
      var v = parseDkk(els[i].textContent);
      if (!isNaN(v)) return { cents: v, text: els[i].textContent };
    }
    return null;
  }
  function syncAll() {
    var sub = readSubtotal();
    if (!sub) return;
    var label = currencyLabel(sub.text);
    var boxes = document.querySelectorAll('[data-ed-cart-shipping]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var scope = box.closest('.cart-drawer__footer, .js-contents') || document;
      var own = scope.querySelector('[bss-b2b-cart-total-price]');
      var s = own ? parseDkk(own.textContent) : sub.cents;
      if (isNaN(s)) s = sub.cents;
      var r = compute(s, parseInt(box.getAttribute('data-threshold'), 10) || 300000, parseInt(box.getAttribute('data-fee'), 10) || 48700);
      var lab = own ? currencyLabel(own.textContent) : label;
      setText(box.querySelector('[data-ed-fragt]'), r.fee === 0 ? 'Gratis' : formatDkk(r.fee, lab));
      setText(box.querySelector('[data-ed-fragt-total]'), formatDkk(r.total, lab));
    }
    var texts = document.querySelectorAll('[data-ed-free-freight-text]');
    for (var j = 0; j < texts.length; j++) {
      var t = texts[j], th = parseInt(t.getAttribute('data-threshold'), 10) || 300000;
      var empty = t.querySelector('[data-ed-ff-state="empty"]');
      if (empty && !empty.hidden) continue; // empty cart: leave as rendered
      var free = isFree(sub.cents, th);
      setHidden(t.querySelector('[data-ed-ff-state="left"]'), free);
      setHidden(t.querySelector('[data-ed-ff-state="free"]'), !free);
      setText(t.querySelector('[data-ed-ff-left]'), formatNum(Math.max(th - sub.cents, 1)) + ' kr.');
      var wrap = t.closest('.wbship_wrapper');
      if (wrap) wrap.classList.toggle('wbship_full_wrapper', free);
      var ship = t.closest('.wbship');
      var bar = ship && ship.querySelector('.determinate');
      if (bar) {
        var w = Math.min(100, Math.round(sub.cents * 100 / th)) + '%';
        if (bar.style.width !== w) bar.style.width = w;
        var flag = free ? 'true' : 'false';
        if (bar.getAttribute('data-threshold') !== null && bar.getAttribute('data-threshold') !== flag) bar.setAttribute('data-threshold', flag);
      }
    }
    var heads = document.querySelectorAll('[data-ed-free-freight][data-ed-ff-active]');
    for (var k = 0; k < heads.length; k++) {
      var hth = parseInt(heads[k].getAttribute('data-ed-free-freight'), 10) || 300000;
      setText(heads[k], isFree(sub.cents, hth) ? 'Du har opnået fri fragt' : formatNum(Math.max(hth - sub.cents, 1)) + ' kr. fra fri fragt');
    }
  }
  root.__edCartShipping = { parseDkk: parseDkk, formatDkk: formatDkk, formatNum: formatNum, compute: compute, isFree: isFree, currencyLabel: currencyLabel, syncAll: syncAll };
  if (typeof module !== 'undefined' && module.exports) module.exports = root.__edCartShipping;
  if (typeof document === 'undefined' || !document.addEventListener || root.__edCartShippingLogicOnly) return;
  var pending = false;
  function schedule() { if (pending) return; pending = true; setTimeout(function () { pending = false; syncAll(); }, 50); }
  function start() {
    syncAll();
    if (typeof MutationObserver !== 'undefined') new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})(typeof window !== 'undefined' ? window : this);
